/**
 * LOGOI LAB - useTranslatedDomains Hook
 * 
 * Returns a translated copy of the DOMAINS object using i18n.
 * Preserves the original structure (icons, colors, dim keys) but
 * overlays translated labels, descriptions, and tooltips.
 * 
 * @author Dr. José Manuel Cadena Ortiz de Montellano
 * @framework Cadena Strategic Systems
 */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DOMAINS } from '../domain';

export function useTranslatedDomains() {
  const { t } = useTranslation();

  return useMemo(() => {
    const translated = {};
    for (const [domainKey, domain] of Object.entries(DOMAINS)) {
      const translatedDims = {};
      for (const [dimKey, dim] of Object.entries(domain.dims)) {
        translatedDims[dimKey] = {
          ...dim,
          label: t(`domains.${domainKey}.dims.${dimKey}.label`, dim.label),
          desc: t(`domains.${domainKey}.dims.${dimKey}.desc`, dim.desc),
          tooltip: t(`domains.${domainKey}.dims.${dimKey}.tooltip`, dim.tooltip),
          guideQuestion: t(`domains.${domainKey}.dims.${dimKey}.guideQuestion`, ''),
        };
      }
      translated[domainKey] = {
        ...domain,
        label: t(`domains.${domainKey}.label`, domain.label),
        dims: translatedDims,
      };
    }
    return translated;
  }, [t]);
}
